// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6_P6I","content":"styles_content__17ykY"};